module.exports = __webpack_public_path__ + "img/social_text_sm.89507ed5.svg";